<template>
  <div class="pa-connections-reply-box">
    <div class="body">
      {{message.body}}
    </div>
    
    <div class="date">{{message.created_at | mutateJPSimpleDate}}</div>
    
    <PASimpleMessageAttachImagesView :images="message.images" />
    
    <ul class="controls">
      <li v-if="isVisibleTrashButton">
        <button
         class="button circle-button circle-button-minify"
         :class="trashButtonClass"
         :disabled="isDisabledTrashButton"
         @click.prevent="handleClickTrashButton"
        >
          <font-awesome-icon icon="trash" />
        </button>
      </li>
      <li>
        <CharacterIcon :character="message.character" />
      </li>
    </ul>

    <PodMessageActionConfirm
     :isOpen="isOpenTrashConfirm"
     :isLoading="isLoadingTrashConfirm"
     @handleSubmit="handleConfirmDeleteSubmitButton"
     @handleCancel="handleConfirmDeleteCancelButton"
     />
  </div>
</template>

<script>
import CharacterIcon                    from '@/components/Parts/CharacterIcon/CharacterIcon.vue'
import PASimpleMessageAttachImagesView  from '@/components/Parts/PASimpleMessageAttachImagesView/PASimpleMessageAttachImagesView.vue';
import PodMessageActionConfirm          from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/Parts/PodMessageActionConfirm.vue'

import {DeleteConnectionPodMessage} from '@/graphql/mutations/Pod.graphql'
import {GetMessageData}             from '@/graphql/queries/ConnectionPod.graphql'

export default {
  props : {
    message : {
      default: null
    }
  },

  components : {
    CharacterIcon,
    PASimpleMessageAttachImagesView,
    PodMessageActionConfirm
  },

  data(){
    return {
      trashButtonClass      : [],
      isDisabledTrashButton : false,

      isOpenTrashConfirm    : false,
      isLoadingTrashConfirm : false,
      
      isVisibleTrashButton  : false
    };
  },

  watch : {
    message : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if(typeof data.could_delete !== 'undefined'){
          this.isVisibleTrashButton  = data.could_delete;
          this.isDisabledTrashButton = !data.could_delete;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleClickTrashButton(){
      this.isOpenTrashConfirm = true;
    },

    deleteReplyMessage(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : DeleteConnectionPodMessage,
          variables : {
            podMessageId  : this.message.id
          },
          update    : (store, {data: {DeleteConnectionPodMessage: {status, parentPodMessage}}}) => {
            if(status === false){
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }

            if(parentPodMessage !== null){
              store.writeQuery({
                query     : GetMessageData,
                variables : {
                  id  : parentPodMessage.id
                },
                data      : {
                  podMessage : parentPodMessage
                }
              });
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);

          console.error(errorSet);

          resolve(false);
        });
      });
    },

    async handleConfirmDeleteSubmitButton(){
      this.isLoadingTrashConfirm = true;

      await this.UXWaiting(1000);
      await this.deleteReplyMessage();

      this.isOpenTrashConfirm     = false;
      this.isLoadingTrashConfirm  = false;
    },

    handleConfirmDeleteCancelButton(){
      this.isOpenTrashConfirm     = false;
      this.isLoadingTrashConfirm  = false;
    }
  }
}
</script>

<style lang="scss">
.pa-connections-reply-box{
  position: relative;
  background-color: #C1A27E;
  border-radius: 4px;
  width:95%;
  margin:0 auto;

  .body{
    margin:0 .4rem;
    padding:.5rem;
    font-size:.9rem;
    line-height: 1.2;
    border-bottom:1px solid #BFA07C;
  }

  .attached-images{
    border-top:1px solid #BFA07C;

    margin:.6rem .5rem .4rem;
    padding-top:.6rem;

    ul.items{
      display:flex;
      flex-direction: row;
      justify-content: space-between;
      li{
        width:48%;
        border-radius: 4px;
        position: relative;

        > img{
          width:100%;
          vertical-align: middle;
          border-radius: 4px;
        }
      }
    }
  }

  ul.controls{
    margin-top:.3rem;
    margin-right: .5rem;
    text-align: right;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: inherit;
    line-height: normal;
    padding-bottom: .3rem;

    li{
      margin-left:.3rem;
      margin-bottom: 0 !important;
    }

    .pa-character-icon{
      width:30px;
      height: 30px;
      margin: 0 0 0 auto;
      background-color:#BD9C75;
    }

    .circle-button, .pa-character-icon{
      color:#795B46;
      margin:0;
      padding:0;
      width:30px;
      height:30px;
      border-radius:50%;
      border:0;
      background-color:#BD9C75;
      font-size:.8rem;
      line-height: .8rem;

      &-minify{
        margin-top:5px;
        width:25px;
        height:25px;
      }

      &.pa-character-icon{
        font-size:1.5rem;
        line-height:100%;
        padding-top:.1rem;
      }
    }
  }

  .date{
    position: absolute;
    width:100%;
    left:0;
    bottom:0;
    font-size: .55rem;
    color:#A68864;
    padding:0 0 .3rem .8rem;
  }
}
</style>